import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EnvironmentService } from '../../../core/services/environment.service';
import * as _ from 'lodash';
import { UtilityService } from '../../services/utility/utility.service';

@Component({
    selector: 'upsc-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
})
export class TermsOfUse implements OnInit {

    private lang = '';
    public default = false;
    public de = false;
    public gb = false;

    constructor(@Inject(DOCUMENT) private document: Document,
                private environmentService: EnvironmentService,
                private utilityService: UtilityService,
    ) {
        this.getDomain();
        this.showTerms();
    }

    public ngOnInit() {

    }

    private getDomain() {
        const domainName = this.utilityService.getCurrentDomainName();
        this.lang = _.findKey(this.environmentService.environment.sites, (item) => {
            return domainName.endsWith(item);
        }) || 'en';
    }

    private showTerms() {
        switch (this.lang) {
            case 'en':
                this.default = true;
                this.de = false;
                this.gb = false;
                break;
            case 'de':
                this.default = false;
                this.de = true;
                this.gb = false;
                break;
            case 'en-gb':
                this.default = false;
                this.de = false;
                this.gb = true;
                break;
            default:
                this.default = true;
                this.de = false;
                this.gb = false;
                break;
        }
    }

}
